import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminPanel from "@/components/admin/AdminPanel";
import BetaSignup from "@/components/beta/BetaSignup";
import FeedbackPage from "@/components/feedback/FeedbackPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/beta" element={<BetaSignup />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        {/* Everything else (including / and /reset-password) renders the SPA. */}
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
